import React, { FC } from 'react';
import { Currency } from '@cryptoalgebra/kim-sdk';
import { useVaultsByPool } from '@app/hooks/ichi/useVaultsByPool';
import { VaultSelector } from '../ichi/VaultSelector';
import { VaultInfo } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/VaultInfo';
import { useDerivedLiquidityByIchiInfo } from '@app/state/liquidityByIchiStore';
import { AmountsInput } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/AmountsInput';
import { CreateIchiPositionWithKpNft } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/CreateIchiPositionWithKpNft';

interface Props {
  poolAddress: string;
  currencyA: Currency;
  currencyB: Currency;
}

export const AddLiquidityByIchi: FC<Props> = ({
  poolAddress,
  currencyA,
  currencyB
}) => {
  const { data: vaultsAddresses } = useVaultsByPool(poolAddress);
  const mintInfo = useDerivedLiquidityByIchiInfo(poolAddress);
  const { vaultDetails, isApproved } = mintInfo;

  return (
    <>
      <VaultSelector vaultsAddresses={vaultsAddresses} />
      <VaultInfo vaultDetails={mintInfo.vault} />
      <AmountsInput vaultDetails={vaultDetails} />
      <CreateIchiPositionWithKpNft
        currencyA={currencyA}
        currencyB={currencyB}
        mintInfo={mintInfo}
      />
    </>
  );
};
